// Angular
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
// Permissions
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-gestiones-sidebar-carpetas',
  templateUrl: './gestiones-sidebar-carpetas.component.html',
  styleUrls: ['./gestiones-sidebar-carpetas.component.scss']
})
export class GestionesSidebarCarpetasComponent implements OnInit {
  @Output() changeSegmento = new EventEmitter<number>();
  @Output() refreshPrecas = new EventEmitter<boolean>();
  lstCategories = [];
  constructor(
    private ngxPermissionService: NgxPermissionsService,
  ) {
  }

  ngOnInit(): void {
    this.lstCategories = [
      {
        icon: 'folder.png',
        name: 'Precalificaciones',
        id: 1,
        access: true,
      },
      {
        icon: 'folder.png',
        name: 'Privado',
        id: 2,
        access: this.ngxPermissionService.getPermission('bandejasSegmentoPrivada'),
      },
      {
        icon: 'folder.png',
        name: 'Estado',
        id: 3,
        access: this.ngxPermissionService.getPermission('bandejasSegmentoEstado'),
      },
      {
        icon: 'folder.png',
        name: 'Pago Voluntario',
        id: 5,
        access: this.ngxPermissionService.getPermission('bandejasSegmentoPagoVoluntario'),
      },
    ];
  }
  selectSegemento(id: any) {
    this.changeSegmento.emit(+id);
  }
}
